import React from 'react';
import PlaceholderPage from '../components/PlaceholderPage';

const MembershipPlans = () => <PlaceholderPage title="멤버십 상품" description="구독/수강권 등 멤버십 상품을 관리해요." />;

export default MembershipPlans;
